import styled from "styled-components";

export const DatePickerItemStyled = styled.button`
  border-radius: 10px;
  text-align: center;
  margin: 10px 3px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  transition: background-color 0.5s;

  background-color: ${({
    selectNewRequestBargiryDate,
    selectNewRequestTakhliehDate,
    selectNewRequestCalenderBargiry_show,
    selectNewRequestCalenderTakhlieh_show,
  }) =>
    (selectNewRequestBargiryDate && selectNewRequestCalenderBargiry_show) ||
    (selectNewRequestTakhliehDate && selectNewRequestCalenderTakhlieh_show) 
      ? "#FFBF1D"
      : "#f3f5f4"};
`;
